import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import AdminPanel from './AdminPanel';


// v5 pages
import HomePage from './v5/pages/HomePage';

class Router extends Component {
    render() {
        return (
            <Switch>
                <Route exact path="/" component={ HomePage } />

                <Route path="/admin" component={ AdminPanel } />

                <Redirect from="*" to='/' />
            </Switch>
        );
    }
}

export default Router;
